import React, { useState, useEffect } from 'react';
import AdminLayout from './AdminLayout';
import EmployeesPage from './EmployeesPage';
import ShiftsPage from './ShiftsPage';
import SchedulePage from './SchedulePage';
import RulesPage from './RulesPage';
import PayPeriodsPage from './PayPeriodsPage';
import TimesheetsPage from './TimesheetsPage';

const TABS = [
  { key: 'employees', label: 'Employees', icon: 'fa-id-badge' },
  { key: 'rules', label: 'Rules', icon: 'fa-sliders-h' },
  { key: 'payperiods', label: 'Pay Periods', icon: 'fa-dollar-sign' },
  { key: 'shifts', label: 'Shifts', icon: 'fa-clock' },
  { key: 'schedule', label: 'Schedule', icon: 'fa-calendar-alt' },
  { key: 'timesheets', label: 'Timesheets', icon: 'fa-clipboard-list' },
];

const TeamManagementPage = ({ defaultTab }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || 'employees');

  // Sync active tab when navigating between team management routes
  useEffect(() => {
    if (defaultTab) {
      setActiveTab(defaultTab);
    }
  }, [defaultTab]);

  return (
    <AdminLayout title="Team Management">
      <div className="team-management-page">
        {/* Tabs */}
        <div className="d-flex mb-4" style={{ borderBottom: '2px solid #f0f0f0', gap: 0 }}>
          {TABS.map(tab => (
            <button
              key={tab.key}
              className="btn btn-link text-decoration-none"
              style={{
                padding: '12px 24px',
                fontWeight: 600,
                fontSize: '0.95rem',
                color: activeTab === tab.key ? '#ff6b35' : '#6c757d',
                borderBottom: activeTab === tab.key ? '3px solid #ff6b35' : '3px solid transparent',
                borderRadius: 0,
                marginBottom: -2,
                background: 'none',
                borderLeft: 'none',
                borderRight: 'none',
                borderTop: 'none',
                cursor: 'pointer',
              }}
              onClick={() => setActiveTab(tab.key)}
            >
              <i className={`fas ${tab.icon} mr-2`}></i>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        {activeTab === 'employees' && <EmployeesPage embedded />}
        {activeTab === 'shifts' && <ShiftsPage embedded />}
        {activeTab === 'schedule' && <SchedulePage embedded />}
        {activeTab === 'rules' && <RulesPage embedded />}
        {activeTab === 'payperiods' && <PayPeriodsPage embedded />}
        {activeTab === 'timesheets' && <TimesheetsPage embedded />}
      </div>
    </AdminLayout>
  );
};

export default TeamManagementPage;
